/**
 * Normalização canónica de `origemLead` (CRM) — **ESM puro** para o browser (Vite).
 *
 * A lógica é mantida **idêntica** a:
 * - `shared/crmOrigemLeadNormalize.cjs`
 * - `functions/crmOrigemLeadNormalize.cjs`
 *
 * Ao alterar regras, atualizar os **três** ficheiros (sincronização manual; o frontend não importa o `.cjs`).
 */

/** @param {string} s */
function fold(s) {
  return String(s ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

const CANONICAL = new Set([
  'instagram',
  'google',
  'meta_ads',
  'google_ads',
  'indicacao',
  'outros',
  'site_direto',
  // Emitidos pelo site (select «Como nos conheceu?» e inferência por referrer).
  // Sem eles aqui, o normalize devolvia 'outros' e a origem real perdia-se.
  'linkedin',
  'tiktok',
  'youtube',
]);

/**
 * @param {unknown} value
 * @returns {string} slug canónico ou '' se vazio
 */
export const normalizeOrigemLead = value => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const key = fold(raw);

  if (key === 'insta' || key === 'instagram') return 'instagram';
  if (key === 'google') return 'google';
  if (key === 'facebook_ads' || key === 'instagram_ads' || key === 'meta_ads') return 'meta_ads';
  if (key === 'google_ads') return 'google_ads';
  if (key === 'indicacao') return 'indicacao';

  if (CANONICAL.has(key)) return key;
  return 'outros';
};

/**
 * Valor a gravar no Firestore: nunca fica vazio (mínimo `site_direto`).
 * Com `origemLead` preenchido, só normaliza — não substitui por source.
 *
 * @param {unknown} origemLead
 * @param {unknown} source
 * @returns {string}
 */
export const resolveOrigemLeadForFirestore = (origemLead, source) => {
  const ol = String(origemLead ?? '').trim();
  if (ol !== '') {
    return normalizeOrigemLead(ol);
  }
  const s = String(source ?? '').trim();
  if (s !== '') {
    const fromSrc = normalizeOrigemLead(s);
    if (fromSrc && fromSrc !== 'outros') return fromSrc;
  }
  return 'site_direto';
};
